// src/components/common/print/FormViewPrint.jsx
import { useEffect, useRef } from "react";
import PaperShell from "../layout/PaperShell";
import FormViewPaperContent from "../form/FormViewPaperContent";

export default function FormViewPrint({
  module,
  app_top,
  approvalLines,
  doc_name,
  doc_eng,
  data,
  meta,
  dns,
  project,
  projectName,
  children,
}) {
  const printedRef = useRef(false);

  // ✅ 최초 마운트 시 자동 print
  useEffect(() => {
    if (printedRef.current) return;
    printedRef.current = true;

    // 렌더 완료 후 프린트 (타이밍 중요)
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.print();
      });
    });
  }, []);

  return (
    <PaperShell>
      <FormViewPaperContent
        module={module}
        app_top={app_top}
        approvalLines={approvalLines}
        doc_name={doc_name}
        doc_eng={doc_eng}
        data={data}
        meta={meta}
        dns={dns}
        project={project}
        projectName={projectName}
        print
      >
        {children}
      </FormViewPaperContent>
    </PaperShell>
  );
}
